import { render, staticRenderFns } from "./DetailCourses.vue?vue&type=template&id=de7a872a&scoped=true"
import script from "./DetailCourses.vue?vue&type=script&lang=js"
export * from "./DetailCourses.vue?vue&type=script&lang=js"
import style0 from "./DetailCourses.vue?vue&type=style&index=0&id=de7a872a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7a872a",
  null
  
)

export default component.exports